import { ApiPaths } from 'services/api/apiPaths';
import { createResourceApi } from '../../createResourceApi';

export const shardTypePricingsApi = createResourceApi(ApiPaths.SHARD_TYPE_PRICINGS, (rest) => ({
  calculatePrice: (payload: CalculatorPayload) =>
    rest.post<ShardTypePricingListResponse>({ data: payload }),
  calculateSubscriptionPrice: (payload: CalculatorPayload, subscriptionId: number) =>
    rest.post<ShardTypePricingListResponse>({ path: `${subscriptionId}`, data: payload })
}));
